import React from "react";
import "../../styles/biochemistry/main.css";
import { Link } from "react-router-dom";

const BiochemistrySection = () => {
      const tableStyle = {
      borderCollapse: "collapse",
      width: "100%",
      background: "#fff",
    };

    const thtdStyle = {
      border: "1px solid #000",
      padding: "8px",
      textAlign: "center",
      verticalAlign: "middle",
    };

    const thStyle = {
      ...thtdStyle,
      backgroundColor: "#14297a",
      fontWeight: "bold",
    };

    const semesterHeadingStyle = {
      backgroundColor: "#c6ceedff",
      fontWeight: "bold",
      textAlign: "left",
      fontSize: "16px",
    };

    const totalRowStyle = {
      fontWeight: "bold",
      backgroundColor: "#9eace3ff",
    };

  return (
    <section id="biochemistry" className="biochemistry-section">
      <div className="container">
        <h2 className="my-heading text-center mb-4">
          Biochemistry (Under Chemistry Department)
        </h2>
        <ul className="nav nav-tabs" id="biochemistryTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="about-tab"
              data-bs-toggle="tab"
              data-bs-target="#about"
              type="button"
              role="tab"
              aria-controls="about"
              aria-selected="true"
            >
              About
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="programme-details-tab"
              data-bs-toggle="tab"
              data-bs-target="#programme-details"
              type="button"
              role="tab"
              aria-controls="programme-details"
              aria-selected="false"
            >
              Programme Details
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="faculty-tab"
              data-bs-toggle="tab"
              data-bs-target="#faculty"
              type="button"
              role="tab"
              aria-controls="faculty"
              aria-selected="false"
            >
              Faculty
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="semesters-tab"
              data-bs-toggle="tab"
              data-bs-target="#semesters"
              type="button"
              role="tab"
              aria-controls="semesters"
              aria-selected="false"
            >
              Semesters
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="syllabus-tab"
              data-bs-toggle="tab"
              data-bs-target="#syllabus"
              type="button"
              role="tab"
              aria-controls="syllabus"
              aria-selected="false"
            >
              Syllabus
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="benefits-tab"
              data-bs-toggle="tab"
              data-bs-target="#benefits"
              type="button"
              role="tab"
              aria-controls="benefits"
              aria-selected="false"
            >
              Benefits
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="highlights-tab"
              data-bs-toggle="tab"
              data-bs-target="#highlights"
              type="button"
              role="tab"
              aria-controls="highlights"
              aria-selected="false"
            >
              Highlights
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="scope-tab"
              data-bs-toggle="tab"
              data-bs-target="#scope"
              type="button"
              role="tab"
              aria-controls="scope"
              aria-selected="false"
            >
              Scope
            </button>
          </li>
        </ul>
        <div className="tab-content" id="biochemistryTabsContent">
          <div
            className="tab-pane fade show active"
            id="about"
            role="tabpanel"
            aria-labelledby="about-tab"
          >
            <p>
              An M.Sc. in Biochemistry is a two-year postgraduate program that provides in-depth knowledge of the chemical processes within living organisms, including their structures and functions.
            </p>
<div style={{ textAlign: "start", marginTop: "20px", marginBottom: "18px" }}>
  <p style={{ fontSize: "16px", fontWeight: "500", marginBottom: "15px" }}>
    Follow us on Instagram & YouTube
  </p>
  {/* Instagram */}
  <a
    href="https://www.instagram.com/ccsu_biochemistry/?utm_source=qr&igsh=MXM0N3AxOHdjb2dzag%3D%3D#"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
    style={{ marginRight: "20px", textDecoration: "none" }}
  >
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        background: "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)", // Instagram gradient
        cursor: "pointer",
        transition: "transform 0.3s ease",
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <svg
        role="img"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="white"
      >
        <title>Instagram</title>
        <path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"/>
      </svg>
    </div>
  </a>

  {/* YouTube */}
  <a
    href="https://www.youtube.com/@departmentofchemistryccsum8572"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="YouTube"
    style={{ textDecoration: "none" }}
  >
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        background: "red",
        cursor: "pointer",
        transition: "transform 0.3s ease",
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <svg
        role="img"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="white"
      >
        <title>YouTube</title>
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    </div>
  </a>
</div>
            <p><strong>Covers subjects like:</strong></p>
            <ul>
              <li>General Chemistry / Drug designing and Medicinal Chemistry</li>
              <li>Fundamental Genetics and Microbiology  </li>
              <li>Cytology and Human Physiology </li>
              <li>Bioenergetics and Intermediary Metabolism </li>
              <li>Plant Biochemistry / Environmental Biochemistry </li>
              <li>Advanced Enzymology</li>
              <li>Immunology</li>
              <li>Biostatistics and Bioinformatic </li>
              <li>Bioprocess Engineering and Fermentation Technology </li>
              <li>Molecular Biology</li>
              <li>Clinical Biochemistry / Nutritional Biochemistry</li>
              <li>Biophysics and Biochemical Technology</li>
            </ul>
          </div>

          <div
            className="tab-pane fade"
            id="programme-details"
            role="tabpanel"
            aria-labelledby="programme-details-tab"
          >
            <p><strong>Program Name:</strong> M.Sc. Biochemistry</p>
            <p><strong>Program Level:</strong> P.G.</p>
            <p><strong>Duration:</strong> 02 Years (4 Semesters)</p>
            <p><strong>Nature/Type:</strong> Self Financed</p>
            <p><strong>Number of Seats:</strong> 20+2 (EWS)</p>
            <p><strong>Fee structure:</strong></p>
            <ul>
              <li>Rs. 44,445/- 1st year</li>
              <li>Rs. 42,425/- 2nd Year</li>
            </ul>
            <p><strong>Eligibility Criterion:</strong></p>
            <p>Bachelor’s Degree in any branch of life sciences/ PCM/ CBZ/ MLT, BSc(H)/ B.Sc. (General) as per university rules.</p>
            <hr />
            {/* <p>The M.Sc Biochemistry programme offered by Chaudhary Charan Singh University is designed so that:</p>
            <ul>
              <li>Student gains systematic and coherent understanding of the fundamental concepts in Biological Chemistry and all other related allied Life Science subjects.</li>
              <li>Student gains knowledge of basic aspects of Genetics and Microbiology</li>
              <li>Student will be able to interpret data to address the challenges arising from the huge amount of genomic data and to overcome by analyzing through Biostatistics</li>
              <li>Student will be familiar for Biological database handling and database management of different biological database.</li>
              <li>Student will be able to understand the basic principle of equipment’s, instruments used in the Research laboratories.</li>
              <li>Instrumentation training familiarize the students with real working environments, enhances their knowledge & skills and boosts their confidence to do team work and collaborate with others.</li>
              <li>Six-month project will help them to get familiar with Literature surfing, Designing of protocol, Data Interpretation and content writing</li>
            </ul>
            <hr /> */}
            {/* <h5>Curriculum</h5>
            <ol>
              <li><strong>Comprehensive Curriculum:</strong> The program provides a comprehensive foundation in biochemistry, covering various aspects of the field, including cell biology, intermediary metabolism, and advanced techniques.</li>
              <li><strong>Advanced Studies:</strong> The M.Sc. program provides in-depth study in classical and modern areas of biochemistry, with a strong emphasis on research and hands-on training.</li>
              <li><strong>Multidisciplinary Approach:</strong> The curriculum incorporates elements from other life sciences disciplines, fostering a broader understanding of biological systems.</li>
            </ol> */}
            {/* <h5>Practical & Research Training</h5>
            <ol>
              <li><strong>Hands-on Experience:</strong> Students gain practical experience in experimental biochemistry, using advanced techniques and equipment.</li>
              <li><strong>Instrumentation Training:</strong> To provide the real insight of working procedure and environment of industries. Students will learn advanced tools and techniques, relate, apply and adapt relevant knowledge and skills to compete the job market with this experience and exposure</li>
              <li><strong>Research Projects:</strong> The program encourages students to engage in research, with opportunities for dissertation projects and participation in seminars.</li>
              <li><strong>Research Focus:</strong> Students participate in research projects, gaining valuable experience in designing, executing, and analyzing experiments</li>
            </ol> */}
            <p><b>Research Project evaluation would be based on the following criterion:</b></p>
            <ol>
              <li>Thesis: 50%</li>
              <li>Presentation 25%</li>
              <li>Viva Voce 25%</li>
            </ol>
            <p><i>As per NEP guidelines letter no. DR9103 dt: 07-10-2024, student will be awarded more than 80% marks in their Research project only if a research paper based on work is published/accepted for publication in Journals listed in   UGC care list (if applicable)/ Scopus Indexed/ web of Science indexed.</i></p>
            <hr/>
            <h5><b>Program Specific Outcomes (PSOs):</b></h5>
            <ol>
              <li><b>PSO1:</b> The Programme aims is to understand the fundamental chemical principles that governs complex biological systems.  </li>
              <li><b>PSO2:</b> They will learn several basic and technical skills to work exceptionally in various fields of Biochemistry. </li>
              <li><b>PSO3:</b> It increases the ability to understand the technical aspects of existing technologies that help in addressing the biological and medical challenges faced by humankind.</li>
              <li><b>PSO4:</b> It enhances an ability to acquire in-depth theoretical and practical knowledge of Biochemistry and make students efficient enough to apply the acquired knowledge for providing   solutions to various problems in Biochemistry.</li>
              <li><b>PSO5:</b> Graduates should be able to design and conduct research projects, analyze data, and communicate findings effectively through scientific writing and presentations.</li>
            </ol>
          </div>

          {/* faculty section */}
          <div
          className="tab-pane fade"
          id="faculty"
          role="tabpanel"
          aria-labelledby="faculty-tab"
          >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              width: "450px",
              border: "1px solid #ddd",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {/* Left Image */}
            <div style={{ padding: "20px", textAlign: "center" }}>
              <img
                src="https://cdn.ccsuniversity.ac.in/cv/jpg/P306.jpg" 
                alt="Dr Manisha Bhardwaj"
                style={{ width: "140px", height: "auto" }}
              />
            </div>

            {/* Right Content */}
            <div style={{ padding: "20px", flex: 1 }}>
              <h3
                style={{
                  margin: "0 0 10px",
                  color: "#f36f21",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Dr Manisha Bhardwaj
              </h3>
              <p style={{ margin: "0 0 15px", fontSize: "14px", color: "#000" }}>
                M.Sc. Ph.D. (Biochemistry)
              </p>
              <a
                href="https://cdn.ccsuniversity.ac.in/cv/pdf/Dr.pdf"
                style={{
                  textDecoration: "none",
                  color: "#003399",
                  fontSize: "14px",
                }}
              >
                View Resume
              </a>
            </div>
          </div>
          </div>

          {/* Semister */}

          {/* <div
            className="tab-pane fade"
            id="semesters"
            role="tabpanel"
            aria-labelledby="semesters-tab"
          >
            <h4 className="text-center bg-blue text-white py-2">Semester-I</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Course Code</th>
                            <th>Course Title</th>
                            <th>Duration (Hrs)</th>
                            <th>Lecture Duration (Min)</th>
                            <th>Max. marks=100 (Internal+External)</th>
                            <th>External Exam Duration (Hrs)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CPDBC 1111</td>
                            <td>General Chemistry</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1112</td>
                            <td>Fundamental Genetics & Microbiology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1113</td>
                            <td>Cytology and Human Physiology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1114</td>
                            <td>Bioenergetics and Intermediary Metabolism</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 507</td>
                            <td>General chemistry Practical, Biochemistry Practical 1 & 2</td>
                            <td>-</td>
                            <td>-</td>
                            <td>100</td>
                            <td>3</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5" className="text-end"><strong>Marks Maximum of Semester-I</strong></td>
                            <td><strong>500</strong></td>
                        </tr>
                    </tfoot>
                </table>
                <h4 className="text-center bg-blue text-white py-2">Semester-II</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Course Code</th>
                            <th>Course Title</th>
                            <th>Duration (Hrs)</th>
                            <th>Lecture Duration (Min)</th>
                            <th>Max. marks=100 (Internal+External)</th>
                            <th>External Exam Duration (Hrs)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CPDBC 1121</td>
                            <td>Plant Biochemistry</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1122</td>
                            <td>Advanced Enzymology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1123</td>
                            <td>Immunology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1124</td>
                            <td>Bioinformatics and Biochemical Technology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CH-607</td>
                            <td>Bioinformatics Practical, Biochemistry Practical 3</td>
                            <td>-</td>
                            <td>-</td>
                            <td>100</td>
                            <td>3</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5" className="text-end"><strong>Marks Maximum of Semester-II</strong></td>
                            <td><strong>500</strong></td>
                        </tr>
                    </tfoot>
                </table>
                <h4 className="text-center bg-blue text-white py-2">Semester-III</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Course Code</th>
                            <th>Course Title</th>
                            <th>Duration (Hrs)</th>
                            <th>Lecture Duration (Min)</th>
                            <th>Max. marks=100 (Internal+External)</th>
                            <th>External Exam Duration (Hrs)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CPDBC 1131</td>
                            <td>Bioprocess Engineering & Fermentation Technology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1132</td>
                            <td>Molecular Biology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1133</td>
                            <td>Clinical Biochemistry</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CPDBC 1134</td>
                            <td>Biophysics and Biochemical Technology</td>
                            <td>60</td>
                            <td>60</td>
                            <td>50+50</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>CH-707</td>
                            <td>Biochemistry Practical 4 & 5</td>
                            <td>-</td>
                            <td>-</td>
                            <td>100</td>
                            <td>3</td>
                        </tr>
                        <tr>
                            <td>-</td>
                            <td>15 Days Instrumentation Training</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5" className="text-end"><strong>Marks Maximum of Semester-III</strong></td>
                            <td><strong>500</strong></td>
                        </tr>
                    </tfoot>
                </table>
                <h4 className="text-center bg-blue text-white py-2">Semester-IV</h4>
                <table>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th colspan="2">Six Month Research Project</th>
                            <th>Maximum Marks</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CPDBC PR</td>
                            <td colspan="2">Six Month Research Project</td>
                            <td>600</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <p>* Value Added Course: Medicinal Biochemistry</p>
          </div> */}

          <div
            className="tab-pane fade"
            id="semesters"
            role="tabpanel"
            aria-labelledby="semesters-tab"
          >
          <div style={{ fontFamily: "Arial, sans-serif", background: "#f9f9f9", padding: "20px" }}>
            <h5>M.Sc. (Biochemistry)</h5>
            <p>Semester-wise titles of the Papers and marks distributions </p>

            <table style={tableStyle}>
              <thead>
                <tr>
                  <th rowSpan="2" style={thStyle}>Year</th>
                  <th rowSpan="2" style={thStyle}>Course Code</th>
                  <th rowSpan="2" style={thStyle}>Paper Title</th>
                  <th rowSpan="2" style={thStyle}>Core Compulsory / Elective / Value added</th>
                  <th rowSpan="2" style={thStyle}>Theory / Practical</th>
                  <th colSpan="3" style={thStyle}>Marks</th>
                  <th rowSpan="2" style={thStyle}>Credits</th>
                </tr>
                <tr>
                  <th style={thStyle}>Ext</th>
                  <th style={thStyle}>Int</th>
                  <th style={thStyle}>Total</th>
                </tr>
              </thead>

              <tbody>
                {/* FIRST SEMESTER */}
                <tr>
                  <td colSpan="9" style={{ ...thtdStyle, ...semesterHeadingStyle }}>FIRST SEMESTER</td>
                </tr>
                <tr>
                  <td rowSpan="5" style={thtdStyle}>1</td>
                  <td style={thtdStyle}>CPDBC-1111</td>
                  <td style={thtdStyle}>
                    General Chemistry<br />Or<br />Drug designing and Medicinal Chemistry
                  </td>
                  <td style={thtdStyle}>Elective</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1112</td>
                  <td style={thtdStyle}>Fundamental Genetics and Microbiology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1113</td>
                  <td style={thtdStyle}>Cytology and Human Physiology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1114</td>
                  <td style={thtdStyle}>Bioenergetics and Intermediary Metabolism</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>PR-101</td>
                  <td style={thtdStyle}>
                    Chemistry Practical<br />
                    Biochemistry Practical 1<br />
                    Biochemistry Practical 2
                  </td>
                  <td style={thtdStyle}>Core Compulsory & Ability enhancement</td>
                  <td style={thtdStyle}>Practical</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>08</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td colSpan="5" style={thtdStyle}>Total Marks and Credits</td>
                  <td style={thtdStyle}>380</td>
                  <td style={thtdStyle}>120</td>
                  <td style={thtdStyle}>500</td>
                  <td style={thtdStyle}>24</td>
                </tr>

                {/* SECOND SEMESTER */}
                <tr>
                  <td colSpan="9" style={{ ...thtdStyle, ...semesterHeadingStyle }}>SECOND SEMESTER</td>
                </tr>
                <tr>
                  <td rowSpan="5" style={thtdStyle}>1</td>
                  <td style={thtdStyle}>CPDBC-1121</td>
                  <td style={thtdStyle}>
                    Plant Biochemistry<br />Or<br />Environmental Biochemistry
                  </td>
                  <td style={thtdStyle}>Elective</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1122</td>
                  <td style={thtdStyle}>Advanced Enzymology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1123</td>
                  <td style={thtdStyle}>Immunology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1124</td>
                  <td style={thtdStyle}>Biostatistics and Bioinformatic</td>
                  <td style={thtdStyle}>Core Compulsory & Ability enhancement</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>PR-202</td>
                  <td style={thtdStyle}>
                    Biochemistry Practical 3<br />
                    Bioinformatics and Biostatistics Practical
                  </td>
                  <td style={thtdStyle}>Core Compulsory & Ability enhancement</td>
                  <td style={thtdStyle}>Practical</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>08</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td colSpan="5" style={thtdStyle}>Total Marks and Credits</td>
                  <td style={thtdStyle}>380</td>
                  <td style={thtdStyle}>120</td>
                  <td style={thtdStyle}>500</td>
                  <td style={thtdStyle}>24</td>
                </tr>

                {/* THIRD SEMESTER */}
                <tr>
                  <td colSpan="9" style={{ ...thtdStyle, ...semesterHeadingStyle }}>THIRD SEMESTER</td>
                </tr>
                <tr>
                  <td rowSpan="5" style={thtdStyle}>2</td>
                  <td style={thtdStyle}>CPDBC-1131</td>
                  <td style={thtdStyle}>Bioprocess Engineering and Fermentation Technology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1132</td>
                  <td style={thtdStyle}>Molecular Biology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1133</td>
                  <td style={thtdStyle}>
                    Clinical Biochemistry<br />Or<br />Nutritional Biochemistry
                  </td>
                  <td style={thtdStyle}>Elective</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>CPDBC-1134</td>
                  <td style={thtdStyle}>Biophysics and Biochemical Technology</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Theory</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>04</td>
                </tr>
                <tr>
                  <td style={thtdStyle}>PR-303</td>
                  <td style={thtdStyle}>
                    Biochemistry Practical 4<br />
                    Biochemistry Practical 5<br />
                    15 days Instrumentation Training
                  </td>
                  <td style={thtdStyle}>Core Compulsory & Ability enhancement</td>
                  <td style={thtdStyle}>Practical</td>
                  <td style={thtdStyle}>70</td>
                  <td style={thtdStyle}>30</td>
                  <td style={thtdStyle}>100</td>
                  <td style={thtdStyle}>08</td>
                </tr>
                <tr style={totalRowStyle}>
                  <td colSpan="5" style={thtdStyle}>Total Marks and Credits</td>
                  <td style={thtdStyle}>380</td>
                  <td style={thtdStyle}>120</td>
                  <td style={thtdStyle}>500</td>
                  <td style={thtdStyle}>24</td>
                </tr>

                {/* FOURTH SEMESTER */}
                <tr>
                  <td colSpan="9" style={{ ...thtdStyle, ...semesterHeadingStyle }}>FOURTH SEMESTER</td>
                </tr>
                <tr>
                  <td style={thtdStyle}></td>
                  <td style={thtdStyle}>CPDBC-PRO</td>
                  <td style={thtdStyle}>-</td>
                  <td style={thtdStyle}>Core Compulsory</td>
                  <td style={thtdStyle}>Practical</td>
                  <td style={thtdStyle}>-</td>
                  <td style={thtdStyle}>-</td>
                  <td style={thtdStyle}>500</td>
                  <td style={thtdStyle}>24</td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>

          {/* Syllabus tab */}
          <div
            className="tab-pane fade"
            id="syllabus"
            role="tabpanel"
            aria-labelledby="syllabus-tab"
            >
            <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Syllabus</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>M.Sc. Biochemistry updated syllabus for session 2025-2026</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/msc_biochemistry_syll.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
          </div>

          <div
            className="tab-pane fade"
            id="benefits"
            role="tabpanel"
            aria-labelledby="benefits-tab"
          >
            <ol>
              <li><strong>Interdisciplinary Flavors:</strong> Students take courses from other life science departments to gain a broader perspective</li>
              <li><strong>Professional Development:</strong> The program organizes seminars, group discussions, Quiz, Workshop, symposiums, Research laboratory Visits and other events to enhance students’ professional skills.</li>
              <li><strong>Higher studies:</strong> The program prepares students for Ph.D. studies in biochemistry and related field</li>
              <li><strong>Career Preparation:</strong> The program aims to equip students with the skills and knowledge needed for careers in Medicine, Drug discovery, Agriculture, Biotechnology,</li>
            </ol>
            <h5>Vision</h5>
            <ol>
              <li>To develop strong theoretical and practical background in fundamental concepts of science</li>
              <li>To provide platform to get opportunities in higher education for career advancement in the field of academics and research organizations</li>
              <li>To make the students effective in skills, tools, and techniques required for an industry/ organization or institute</li>
              <li>To expose the students to latest scientific knowledge, techniques and innovations and provide a platform to them to explore their research potential.</li>
            </ol>
          </div>

          <div
            className="tab-pane fade"
            id="highlights"
            role="tabpanel"
            aria-labelledby="highlights-tab"
          >
            <p>Stay tuned for the exciting highlights of the Biochemistry program!</p>
            <img 
              src="https://cdn.ccsuniversity.ac.in/public/jpg/2025/08/biochem0img.jpg" 
              alt="Biochemistry Highlights" 
              className="img-fluid w-full h-auto rounded-lg shadow-md" 
            />
          </div>

          {/* Scope Tab */}
          <div
            className="tab-pane fade"
            id="scope"
            role="tabpanel"
            aria-labelledby="scope-tab"
            >
            <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Scope</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Future Scope of Biochemistry</td>
                                                <td>
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/BIOCHEM_FLEX%20f.pdf"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default BiochemistrySection;
